import { FC } from 'react';
import { Container, Link, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { Footer } from '@bizapp-lp/workflow/organisms/Footer';
import { Header } from '@bizapp-lp/workflow/organisms/Header';

interface CompleteStyleProps {
  withChildren?: boolean;
}

const useStyle = makeStyles<Theme, CompleteStyleProps>((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#ffffff',
    },
    header: {
      padding: '40px 16px',
      backgroundColor: '#f2f3fb',
      color: '#333333',
      '& .MuiTypography-h1': {
        fontSize: '32px',
        lineHeight: '48px',
        fontWeight: 'bold',
        textAlign: 'center',
        [theme.breakpoints.down(768)]: {
          fontSize: '24px',
          lineHeight: '36px',
        },
      },
    },
    message: (props: CompleteStyleProps) => ({
      margin: props.withChildren ? '40px auto 64px' : '40px auto 117px',
      padding: '0 16px',
      textAlign: 'center',
      '& .MuiTypography-h2': {
        color: '#0ec6bd',
        fontSize: '28px',
        lineHeight: '42px',
        fontWeight: 'bold',
        textAlign: 'center',
        [theme.breakpoints.down(768)]: {
          fontSize: '20px',
          lineHeight: '36px',
        },
      },
      '& .MuiTypography-body1': {
        fontSize: '14px',
        lineHeight: '21px',
        fontWeight: 'normal',
        textAlign: 'center',
        margin: '24px auto 40px',
      },
    }),
    link: {
      color: '#1565c0',
      fontSize: '14px',
      lineHeight: '21px',
      fontWeight: 'normal',
    },
  }),
);

export interface CompleteProps {
  className?: string;
  heading1?: string | JSX.Element;
  heading2?: string | JSX.Element;
  description?: string | JSX.Element;
  children?: string | JSX.Element | JSX.Element[];
}

const Complete: FC<CompleteProps> = ({
  className,
  heading1,
  heading2,
  description,
  children,
}: CompleteProps) => {
  const classes = useStyle({ withChildren: !!children });
  return (
    <>
      <Header from="workflow" />
      <Container
        disableGutters
        maxWidth={false}
        className={`${classes.root} ${className ?? ''}`}
      >
        <Container
          component="header"
          disableGutters
          maxWidth={false}
          className={classes.header}
        >
          <Typography variant="h1">{heading1}</Typography>
        </Container>
        <Container
          component="section"
          disableGutters
          maxWidth={false}
          className={classes.message}
        >
          <Typography variant="h2">{heading2}</Typography>
          <Typography variant="body1" component="p">
            {description}
          </Typography>
          {children}
          <Link
            className={classes.link}
            href="https://www.worksap.co.jp/saas/workflow"
          >
            TOPページへ戻る
          </Link>
        </Container>
      </Container>
      <Footer />
    </>
  );
};

export default Complete;
